import { useEffect } from 'react'
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom'
import Footer from './components/Footer'
import { Icon } from './components/Icons'
import Navbar from './components/Navbar'
import EnquiryPopup from './components/EnquiryPopup'
import About from './pages/About'
import Booking from './pages/Booking'
import Corporate from './pages/Corporate'
import Destinations from './pages/Destinations'
import Experiences from './pages/Experiences'
import Holidays from './pages/Holidays'
import Home from './pages/Home'
import ManagePackages from './pages/ManagePackages'
import PackageDetails from './pages/PackageDetails'

// ── Scroll to Top on Route Change ──────────────────────────────────────
function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [pathname])
  return null
}
// 60148538006
// ── Floating WhatsApp button ──────────────────────────────────────────
function WhatsAppFloat() {
  return (
    <div className="whatsapp-float">
      <a
        href="https://wa.me/7092210922"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float-link"
      >
        {/* <span className="whatsapp-float-text">Chat with us</span> */}
        <div className="whatsapp-float-icon-wrap">
          <Icon name="whatsapp" size={26} color="#fff" />
        </div>
      </a>
    </div>
  )
}

// ── Layout Wrapper ───────────────────────────────────────────────────
function Layout({ children }) {
  const location = useLocation()
  const activePage = location.pathname === '/' ? 'home' : location.pathname.split('/')[1]
  const isManagePackages = location.pathname === '/manage-packages-by-ohw'

  if (isManagePackages) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <main style={{ flex: 1 }}>{children}</main>
      </div>
    )
  }

  return (
  <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
    <Navbar activePage={activePage} />

    <main style={{ flex: 1 }}>
      {children}
    </main>

    <Footer />

    <WhatsAppFloat />

    <EnquiryPopup />
  </div>
)
}

// ── App ───────────────────────────────────────────────────────────────
export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/holidays" element={<Holidays />} />
          <Route path="/destinations" element={<Destinations />} />
          <Route path="/corporate" element={<Corporate />} />
          <Route path="/experiences" element={<Experiences />} />
          <Route path="/about" element={<About />} />
          <Route path="/package/:packageName" element={<PackageDetails />} />
          <Route path="/booking/:packageName" element={<Booking />} />
          <Route path="/manage-packages-by-ohw" element={<ManagePackages />} />
          {/* Fallback */}
          <Route path="*" element={<Home />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  )
}
